import { useQuery } from '@tanstack/react-query'
import {
  listAllLatestAIEyeStatusDataRequest,
  listAllLatestLoadCellWeightDataRequest,
  listAllRecentLoadCellWeightSummaryRequest,
  listAllLatestAIEyeImageCatalogRequest,
} from '../../apis/calyxSaaSDashboardAPI'

export const SCALE_STATUS_AUTO_REFRESH_INTERVAL_MS = 60 * 1000

/**
 * Scales 頁的四支「全部設備」狀態 API。
 *
 * Auto-Refresh 開啟時由 react-query 每 60 秒輪詢；分頁在背景時跳過
 * （refetchIntervalInBackground: false），回到前景時若資料已超過 60 秒就補抓一次
 * （refetchOnWindowFocus + staleTime）。關閉時只在掛載時抓一次。
 */
export const useScaleStatusQueries = (autoRefreshMode: boolean) => {
  const refetchInterval: number | false = autoRefreshMode ? SCALE_STATUS_AUTO_REFRESH_INTERVAL_MS : false
  const autoRefreshQueryOptions = {
    refetchInterval,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: autoRefreshMode,
    staleTime: autoRefreshMode ? SCALE_STATUS_AUTO_REFRESH_INTERVAL_MS : 0,
  }

  const allLatestAIEyeStatusDataQuery = useQuery(
    ['allLatestAIEyeStatusData'],
    () => listAllLatestAIEyeStatusDataRequest(),
    autoRefreshQueryOptions,
  )
  const allLatestLoadCellWeightDataQuery = useQuery(
    ['allLatestLoadCellWeightData'],
    () => listAllLatestLoadCellWeightDataRequest(),
    autoRefreshQueryOptions,
  )
  const allRecentLoadCellWeightSummaryQuery = useQuery(
    ['allRecentLoadCellWeightSummary'],
    () => listAllRecentLoadCellWeightSummaryRequest(),
    autoRefreshQueryOptions,
  )
  const allLatestAIEyeImageCatalogQuery = useQuery(
    ['allLatestAIEyeImageCatalog'],
    () => listAllLatestAIEyeImageCatalogRequest(),
    autoRefreshQueryOptions,
  )

  return {
    allLatestAIEyeStatusDataQuery,
    allLatestLoadCellWeightDataQuery,
    allRecentLoadCellWeightSummaryQuery,
    allLatestAIEyeImageCatalogQuery,
  }
}
